/**
 * Validates an app id against the same rules the OCP CLI enforces (see ocp-cli
 * `app/init` — `APP_ID_FORMAT = /^[a-z][a-z_0-9]{2,31}$/`), returning the first failing
 * rule's message or `undefined` when valid. Empty input returns `undefined` — emptiness is
 * handled by the required field + disabled submit, not an inline error.
 */
export function validateAppId(value: string): string | undefined {
  if (!value) return undefined;
  if (!/^[a-z]/.test(value)) {
    return 'Must start with a lower case letter.';
  }
  if (!/^[a-z_0-9]+$/.test(value)) {
    return 'Can only contain lower case letters, numbers, and underscores.';
  }
  if (/_$/.test(value)) {
    return 'Should not end with an underscore.';
  }
  if (value.length < 3 || value.length > 32) {
    return 'Must be between 3 and 32 characters long.';
  }
  return undefined;
}
